'use strict';

function LoanOffersMogoNoOffer() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.analytics = new Analytics();

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    var _this = this;

    this._super();
    mogo.ready(function () {
      _this._createDisclaimer();
    });
  };

  this.initPage = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  // Legal Disclaimer:
  this._createDisclaimer = function () {
    var legal = $('.js--legal-disclaimer', this._$node);
    var legalElem = '[data-legal]:visible';
    if (legal.length) {
      legal.mogo().create('LegalDisclaimer', {
        legal: $(legalElem, this._$node),
        presenter: this.presenter
      });
    }
  };

  this.destroy = function () {};
}